<template>
  <div>
    <!-- calendario de provas -->
    <section>
      <div class="container" v-if="dados!=''" style="padding: 20px;">
        <div class="row">
          <!-- Card Esquerdo -->
          <div class="card col-lg-6" style="background-color: #F3F3F3;padding: 20px;">
            <h3 style="color:#174171;">{{ $localeField(dados[0], 'itiNome') }}</h3>
            <p style="color:#333333;">{{ $localeField(dados[0], 'itiCampoExtra1') }}</p>
            <form action="#" class="comment-form">
                  <div class="row">
                      <div class="col-lg-12">
                          <input type="text" v-model="Nome" :placeholder="$t('contact.yourName')" style="background-color: rgb(255, 255, 255);padding: 10px;margin-bottom: 10px;border-radius: 5px;width: 100%;">
                      </div>
                      <div class="col-lg-6">
                          <input type="text" v-model="Email"  :placeholder="$t('contact.yourEmail')" style="background-color: rgb(255, 255, 255);padding: 10px;margin-bottom: 10px;border-radius: 5px;width: 100%;">
                      </div>
                      <div class="col-lg-6">
                          <input type="text" v-model="Telefone"  :placeholder="$t('contact.yourWhatsapp')" style="background-color: rgb(255, 255, 255);padding: 10px;margin-bottom: 10px;border-radius: 5px;width: 100%;">
                      </div>
                      <div class="col-lg-12" style="text-align: center">
                          <button @click.prevent="EnviaEmail()" class="btn btn-info" style="margin-top: 0px !important;">{{ $t('callAction.downloadCalendar') }}</button>
                      </div>
                  </div>
              </form>
          </div>

          <!-- Card Direito -->
          <div class="card col-lg-6" v-if="redes!=''" :style="{ backgroundImage: 'url(' + $imgURL + dados[0].insInstitucionalImagens[0].itgUrlImagem + ')', backgroundSize: 'cover', height: '300px', padding: '20px' }">
            <div class="background-image">
              <div class="overlay">
                <h3 style="color:#174171;font-weight: 500;">{{ $localeField(dados[0], 'itiCampoExtra2') }}</h3>
                <p style="color:#333333;">{{ $localeField(dados[0], 'itiCampoExtra3') }}</p>
                <div class="social" style="text-align: center;padding-top: 40px;;">
                  <a v-if="redes[0].itiNome != '' && redes[0].itiNome != null" :href="redes[0].itiNome" class="social-icon" target="_blank" title="Facebook">
                    <i class="fa fa-facebook"></i>
                  </a>
                  <a v-if="redes[0].itiReferencia != '' && redes[0].itiReferencia != null" :href="redes[0].itiReferencia" class="social-icon" target="_blank" title="Instagram">
                    <i class="fa fa-instagram"></i>
                  </a>
                  <a v-if="redes[0].itiCampoExtra1 != '' && redes[0].itiCampoExtra1 != null" :href="redes[0].itiCampoExtra1" class="social-icon" target="_blank" title="Youtube">
                    <i class="fa fa-youtube"></i>
                  </a>
                  <a v-if="redes[0].itiCampoExtra2 != '' && redes[0].itiCampoExtra2 != null" :href="redes[0].itiCampoExtra2" class="social-icon" target="_blank" title="Linkedin">
                    <i class="fa fa-linkedin"></i>
                  </a>
                </div>

              </div>
            </div>
          </div>
        </div>
  </div>     
    </section>
    <!-- calendario de provas -->
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: 'PageCallAction',
  components: {

  },
  data: () => ({
    dados: [],
    contato: [],
    Nome: '',
    Email: '',
    Telefone: '',
    Assunto: '',
    Mensagem: '',
    redes:[],
  }),
  methods: {
    EnviaEmail() {
      if (this.Nome == '') {
        this.$mensagemAviso(this.$t('common.nameRequired'))
      }
      else if (this.Email == '') {
        this.$mensagemAviso(this.$t('common.emailRequired'))
      }
      else {
        let _dadosEmail = {
          nomeDe: this.Nome,
          nomePara: "Sub4 Turismo",
          assunto: 'Contato do Site Form Calendario Sub4 Turismo - ' + this.Nome,
          destinatario: this.dados[0].itiReferencia,
          emailResposta: this.Email,
          textoEmail: "Nome: " + this.Nome + "<br>" + "E-mail: " + this.Email + "<br>Telefone: " + this.Telefone,
          nomeAnexo: '',
          anexo: '',
          tipoAnexo: ''
        }
        axios.post(`/Process/AdmControleSmtp/Enviamail`, _dadosEmail)
          .then(response => {
            if (response.data >= 1) {
                let _url = this.$imgURL + this.dados[0].insInstitucionalArquivos[0].iagUrlArquivo;
              window.open(_url, '_blank');
              this.Nome = "";
              this.Email = "";
              this.Telefone = "";
              this.Assunto = "";
              this.Mensagem = "";
            }
          });
      }
    },
  },
  created() {  
    axios.get('/Process/InsInstitucional/institucional/39/callaction')
         .then(response => {
         this.dados = response.data;
         console.log('this.dados')
         console.log(this.dados)
       })
       .catch(error => {
         console.error(error);
       });

       axios.get('/Process/InsInstitucional/institucional/20/redessociais')
         .then(response => {
         this.redes = response.data;
       })
       .catch(error => {
         console.error(error);
       });
  
  }
}
</script>

<style>
.social .social-icon {
  display: inline-block;
  width: 80px; /* Largura do círculo */
  height: 80px; /* Altura do círculo */
  line-height: 80px; /* Centraliza o ícone verticalmente */
  border-radius: 50%; /* Cria o formato circular */
  background-color: #f0f0f0; /* Cor de fundo do círculo */
  margin: 10px;
  text-align: center; /* Centraliza o ícone horizontalmente */
  transition: background-color 0.3s ease; /* Transição suave */
}

.social .social-icon i {
  font-size: 40px; /* Tamanho do ícone */
  color: #174171; /* Cor do ícone */
  margin-top: 20px;
}

.social .social-icon:hover {
  background-color: #d0d0d0; /* Muda a cor ao passar o mouse */
}
</style>
